var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$store.state.adminPlusVersion)?_c('NavbarAdminPlus',_vm._g(_vm._b({},'NavbarAdminPlus',_vm.$props,false),_vm.$listeners)):_c('NavbarLegacy',_vm._g(_vm._b({},'NavbarLegacy',_vm.$props,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }